export const columnTablePartnerFilesList = [
  { heading: 'Nome do arquivo', value: 'filename' },
  { heading: 'Status', value: 'status' },
  { heading: 'Tipo', value: 'type' },
  { heading: 'Data de criação', value: 'creationDate' },
  { heading: 'Data processamento/agendamento', value: 'scheduleDate' },
];

// Trata os status da api getPartnerFiles
export const formatStatus = (status) => {
  switch (status) {
    case 'registered':
      return 'Registrado';
    case 'validated':
      return 'Validado';
    case 'processed':
      return 'Processado';
    case 'validationError':
      return 'Validado com erro';
    case 'canceled':
      return 'Cancelado';
    case 'processing':
      return 'Processando';
    case 'processedError':
      return 'Processado com erro';
    case 'ready':
      return 'Aguardando';
    default:
      return status;
  }
};
